// partitionByStatus.js — pure helper for the Adapters panel status grouping.
//
// Cursor-parity: status-first layout. Splits a (already search/kind-filtered)
// list of adapters into two buckets keyed by connection status, using the
// SAME source of truth the dropdowns use — adapterConnected() from
// useUnifiedModels (cloud → has_api_key; local → is_active).
//
// CAVEAT (honest labels): "connected" here means key-presence / active flag,
// NOT reachability. It does NOT imply the provider answered a request. The UI
// labels reflect this ("Sem chave / inativo" vs "Conectado").
//
// Returns { attention, connected } preserving input order within each bucket.
// "attention" (NOT connected) is intended to render FIRST.

import { adapterConnected } from '../../../hooks/useUnifiedModels.js';

export function partitionByStatus(adapters) {
  const list = Array.isArray(adapters) ? adapters : [];
  const attention = [];
  const connected = [];
  for (const a of list) {
    if (adapterConnected(a)) connected.push(a);
    else attention.push(a);
  }
  return { attention, connected };
}
